import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../features/auth/authSlice";
import { useAppDispatch } from "../../../app/hooks";
import "../../../center admin css/centerAdmin.css";

const NavBar = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());

    sessionStorage.clear();
    localStorage.clear();

    instance.logoutRedirect({
      postLogoutRedirectUri: "/login",
    });
  };

  return (
    <nav
      style={{ padding: "10px", display: "flex", justifyContent: "flex-end" }}
    >
      {/* <div style={{ fontWeight: 'bold' }}>My App</div> */}
      {isAuthenticated ? (
        <button onClick={handleLogout} style={{ border: "1px solid black" }}>
          Logout
        </button>
      ) : null}
    </nav>
  );
};

export const LogoutButton: React.FC = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect();
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  //   return (
  //     <button
  //       onClick={handleLogout}
  //       style={{
  //         border: "1px #16c0bd solid",
  //         background: "#16c0bd",
  //         borderRadius: "10px",
  //         color: "white",
  //       }}
  //     >
  //       Logout
  //     </button>
  //   );
  // };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <button
        onClick={() => navigate("/new-dashboard")}
        style={{
          border: "1px #16c0bd solid",
          background: "#16c0bd",
          borderRadius: "10px",
          color: "white",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        Dashboard
      </button>

      <button
        onClick={handleLogout}
        style={{
          border: "1px #16c0bd solid",
          background: "#16c0bd",
          borderRadius: "10px",
          color: "white",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default NavBar;
